"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var modules_1 = require("./modules");
exports.default = {
    MARKET_TOPICS_PAGE: [
        {
            entitlement: "B2B2024_PageMarketTopics",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
    MARKET_TRENDS_PAGE: [
        {
            entitlement: "B2B2024_PageMarketTrends",
            launchDarkly: "b2b-market-trends-page",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
    MARKET_TOPIC_DETAIL_PAGE: [
        {
            entitlement: "B2B2024_PageMarketTopicDetail",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
    MARKET_INSIGHTS_PAGE: [
        {
            entitlement: "B2B2024_PageMarketInsights",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
    MARKET_PEERS_PAGE: [
        {
            entitlement: "B2B2024_PageMarketPeers",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
    MARKET_COMPETITORS_PAGE: [
        {
            entitlement: "B2B2024_AppReviewInsights",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
    MARKET_COMPETITORS_WITH_RI_PAGE: __spreadArray([
        {
            entitlement: "B2B2024_AppReviewInsights",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    COMPETITORS_TOPIC_SCORES: __spreadArray([
        {
            entitlement: "B2B2024_ComponentCompetitorTopicScores",
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    COMPETITORS_REVIEWS: __spreadArray([
        {
            entitlement: "B2B2024_ComponentCompetitorReviews",
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    COMPETITOR_TOPIC_PERFORMANCE: __spreadArray([
        {
            entitlement: "B2B2024_ComponentCompetitorTopicPerformance",
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
    COMPETITOR_FILTERS: __spreadArray([
        {
            entitlement: "B2B2024_ComponentCompetitorFilters",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        }
    ], __read(modules_1.legacyReviewInsightsModuleAccess), false),
};
//# sourceMappingURL=market-insights.js.map